import React from "react";
import "./GenericHero.scss";
import Button from "../Button/Button";

interface GenericHeroProps {
  head: string;
  text: string;
  hImg: string;
  hAlt: string;
  btnContent: string;
  btnLink: string;
  btn2Content: string;
  btn2Link: string;
}

export default function GenericHero(props: GenericHeroProps) {
  const { head, text, hImg, hAlt, btnContent, btnLink, btn2Content, btn2Link } =
    props;

  return (
    <div className="genericHero">
      <section className="genericHero__left">
        <h1 className="genericHero__head">{head}</h1>
        <p className="genericHero__text">{text}</p>
        <div className="genericHero__wrapper">
          <a href={btnLink} className="genericHero__link">
            <Button
              classtitle="button button--primary button__genHero--1"
              content={btnContent}
            />
          </a>
          <a href={btn2Link} className="genericHero__link">
            <Button
              classtitle="button button--secondary button__genHero--2"
              content={btn2Content}
            />
          </a>
        </div>
      </section>
      <section className="genericHero__right">
        <img src={hImg} alt={hAlt} className="genericHero__img" />
      </section>
    </div>
  );
}
